import { useEffect, useRef } from "react";

const useFocusOnError = ({
  fieldRef,
  name,
  formikProps: { submitCount, errors, isValid },
}: {
  fieldRef: any;
  name: string;
  formikProps: any;
}) => {
  const prevSubmitCountRef = useRef(submitCount);
  const firstErrorKey = Object.keys(errors)[0];
  useEffect(() => {
    if (
      prevSubmitCountRef.current !== submitCount &&
      !isValid &&
      fieldRef.current &&
      firstErrorKey === name
    ) {
      try {
        fieldRef.current.focus();
      } catch {
        const element = document.getElementById(firstErrorKey);
        if (element !== null) {
          element.focus();
        }
      }
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount]);
};

export default useFocusOnError;
